import { JetsSeatMap } from "@chqfly/jets-seatmap-react-lib-pub";
import { useLocalStorageState } from "ahooks";
import dayjs from "dayjs";

import { useMemo, useState } from "react";

import { CircularProgress } from "@mui/material";

import seatmap_guide from "@/assets/seatmap.png";
import { CLASS_CODE_MAP, INIT_DATA } from "@/components/SitemapDialog/constants";
import "@/components/SitemapDialog/styles.css";
import request from "@/utils/request";

import SearchBar, { SearchConditionType } from "./components/SearchBar";

const Loading = () => {
  return (
    <div className="flex justify-center items-center h-[300px]">
      <div className="text-center">
        <CircularProgress />
        <div>Loading...</div>
      </div>
    </div>
  );
};

const LiveSeatMap = () => {
  const [availabilityData, setAvailabilityData] = useState([]);

  const [condition, setCondition] = useState<SearchConditionType>();

  const data = useMemo(() => {
    const flightItem = condition;

    if (!flightItem) {
      return { ...INIT_DATA, flight: null };
    }

    const flightData = {
      id: flightItem.airline[0].value + flightItem?.flightNumber,
      airlineCode: flightItem.airline[0].value,
      flightNo: flightItem.flightNumber,
      departureDate: dayjs(flightItem?.oneWayDate).format("YYYY-MM-DD"),
      departure: flightItem?.fromLocation[0]?.iata,
      arrival: flightItem?.toLocation[0].iata,
      cabinClass:
        CLASS_CODE_MAP[flightItem?.cabinClass as keyof typeof CLASS_CODE_MAP].toLocaleUpperCase(),
    };

    return { ...INIT_DATA, flight: flightData };
  }, [condition]);

  return (
    <div className="max-w-[1280px] justify-center mx-auto px-[10px] my-[20px]">
      <div className="flex flex-col md:flex-row gap-[20px]">
        <div className="w-full md:w-[400px]">
          <SearchBar loading={false} onSearch={setCondition} />
        </div>
        <div className="flex-1 bg-[#F1F3FB] relative md:h-[90vh]">
          {condition && (
            <div className="flex justify-center pt-[10px] h-full md:overflow-y-auto">
              <JetsSeatMap
                config={{
                  apiUrl: "https://www.awardtool-api.com",
                  apiAppId: "demo",
                  apiKey: "demo",
                  ...data.config,
                  request: request,
                }}
                availability={availabilityData}
                flight={data.flight}
                componentOverrides={{
                  JetsNotInit: Loading,
                }}
                onSeatMapInited={(d: any) => {
                  if (d?.availabilityData?.availableSeats) {
                    setAvailabilityData(d.availabilityData.availableSeats);
                  }
                }}
                key={condition?.flightNumber}
              />

              <div
                className="absolute bottom-[10px] right-[10px] w-[160px] p-[4px] bg-white z-10"
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                }}
              >
                <div className="mb-[10px] text-black px-[9px]">Seat Map Key</div>
                <img className="size-full" src={seatmap_guide} alt="" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default LiveSeatMap;
